import axiosInstance from "../axiosInterceptor";

export async function getExamPrepDoc() {
    const response = await axiosInstance.get(`admin/freeDocuments/getFreeDocumentsWithoutPagination`);
    const data = response?.data;
    return data;
}